import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./components/ui/dialog";
import { useDispatch, useSelector } from "react-redux";
import { BasketActions, DialogActions } from "./sagas/actions";
import { ActionButtons } from "./sagas/dialogReducer";
import { useNavigate } from "react-router-dom";
import { Button } from "./components/ui/button";
import { ButtonIcon } from "./ButtonIcon";
import { PlusCircledIcon } from "@radix-ui/react-icons";


export const DialogHelper = () => {
    const dialog = useSelector((state: any) => state.dialog);
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const [added, setAdded] = useState(false);


    useEffect(() => {
        setShow(dialog.show);
    }, [dialog]);


    const toggleDialog = (open: boolean) => {
        if (open) {
            dispatch({ type: DialogActions.SHOW_DIALOG });
        } else {
            dispatch({ type: DialogActions.HIDE_DIALOG });
            setAdded(false);
        }
    }

    const handleShowBasket = () => {
        dispatch({ type: DialogActions.HIDE_DIALOG });
        navigate('/basket');
    }

    const handleAddToBasket = (item: any) => () => {
        dispatch({ type: BasketActions.ADD_TO_BASKET, payload: item });
        setAdded(true);
    }


    return (
        < Dialog open={show} onOpenChange={(open) => toggleDialog(open)}>
            <DialogContent>
                <DialogHeader className="border-b border-line-2 pb-3">
                    <DialogTitle className="text-[17px] font-semibold text-ink">{dialog.title}</DialogTitle>
                    <DialogDescription asChild>
                        <div className="mt-1 text-[13.5px] text-ink-2">{dialog.message}</div>
                    </DialogDescription>
                </DialogHeader>

                <div className="flex flex-wrap items-center gap-2">
                    {dialog.actionButtons && dialog.actionButtons.map((action: any) => {
                        switch (action) {
                            case ActionButtons.ADD_TO_BASKET:
                                return !added
                                    ? <ButtonIcon icon={<PlusCircledIcon />} key={action} onClick={handleAddToBasket(dialog.item)}>Add to basket</ButtonIcon>
                                    : <div key={action} className="text-[13px] italic text-ink-3">Added to basket</div>
                            case ActionButtons.DIRECT_DOWNLOAD:
                                return (
                                    <a
                                        key={action}
                                        href={dialog.info}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="nz-mono w-full break-all rounded-md border border-line bg-surface-2 p-3 text-[12.5px] text-brand hover:underline"
                                    >
                                        {dialog.info}
                                    </a>
                                )
                            case ActionButtons.SHOW_BASKET:
                                return <Button key={action} onClick={handleShowBasket}>Show basket</Button>
                            case ActionButtons.DISMISS:
                                return <Button key={action} variant="outline" onClick={() => toggleDialog(false)}>Dismiss</Button>
                            default:
                                return <Button key={action} variant="outline" disabled>Unknown action</Button>
                        }
                    })}
                </div>
            </DialogContent>
        </Dialog >
    )

}